export default "__VITE_ASSET__CEHXQmFI__"